import { Avatar } from 'antd'
import { UserOutlined } from '@ant-design/icons'

export const TASKS = [
  {
    id: '1',
    idTask: 'TS0001245',
    name: 'UX sketches',
    status: 'To Do',
    image: <Avatar icon={<UserOutlined />} />,
    time: '8 hrs',
    days: '5 days left',
    level: 'Hard',
  },
  {
    id: '2',
    status: 'In Progress',
    idTask: 'TS0001245',
    name: 'UX sketches',
    image: <Avatar icon={<UserOutlined />} />,
    time: '6 hrs',
    days: '6 days left',
    done: false,
    level: 'Hard',
  },
  {
    id: '3',
    status: 'Done',
    idTask: 'TS0001245',
    name: 'UX sketches',
    image: <Avatar icon={<UserOutlined />} />,
    time: '13 hrs',
    days: '4 days left',
    level: 'Hard',
  },
  {
    id: '4',
    status: 'New Order',
    idTask: 'TS0001245',
    name: 'UX sketches',
    image: <Avatar icon={<UserOutlined />} />,
    time: '22 hrs',
    days: '2 days left',
    done: true,
    level: 'Hard',
  },
  {
    id: '5',
    status: 'In Progress',
    idTask: 'TS0001245',
    name: 'UX sketches',
    image: <Avatar icon={<UserOutlined />} />,
    time: '2 hrs',
    days: '1 day left',
    newOrder: true,
    done: false,
    level: 'Hard',
  },
  {
    id: '6',
    status: 'Done',
    idTask: 'TS0001245',
    name: 'UX sketches',
    image: <Avatar icon={<UserOutlined />} />,
    time: '20 hrs',
    days: '11 days left',
    done: true,
    level: 'Hard',
  },
  {
    id: '7',
    idTask: 'TS0001245',
    name: 'UX sketches',
    status: 'In Review',
    image: <Avatar icon={<UserOutlined />} />,
    time: '2 hrs',
    days: '1 day left',
    done: false,
    level: 'Hard',
  },
  {
    id: '7',
    idTask: 'TS0001245',
    name: 'UX sketches',
    status: 'In Review',
    image: <Avatar icon={<UserOutlined />} />,
    time: '2 hrs',
    days: '1 day left',
    done: false,
    level: 'Hard',
  },
  {
    id: '7',
    idTask: 'TS0001245',
    name: 'UX sketches',
    status: 'In Review',
    image: <Avatar icon={<UserOutlined />} />,
    time: '2 hrs',
    days: '1 day left',
    done: false,
    level: 'Hard',
  },
  {
    id: '7',
    idTask: 'TS0001245',
    name: 'UX sketches',
    status: 'In Review',
    image: <Avatar icon={<UserOutlined />} />,
    time: '2 hrs',
    days: '1 day left',
    done: false,
    level: 'Hard',
  },
]
